import React, {useState} from 'react';
import {TextField, Button} from "@material-ui/core";

const AddZoneHeader = (props) => {
	const [name, setName] = useState('');

	const onChangeName = event => {
		setName(event.target.value);
	};

	const onSubmit = event => {
		if( props.center && name && name.trim().length ) {
			props.saveZone(name);
		}
	};

	let content = <p>Click on the map and resize the circle to select a zone.</p>;
	if( props.center ) {
		content = (<div className='AddZoneHeaderForm'>
			<TextField label='Zone Name' placeholder='Name this zone' value={name} onChange={onChangeName} />
			<Button size='small' variant="contained" color='primary' onClick={onSubmit}>Add Zone</Button>
		</div>);
	}

	return (
		<div className='AddZoneHeader'>
			{content}
		</div>
	);
};

export default AddZoneHeader;